import { Helmet } from 'react-helmet';
import { useEffect } from 'react';

function Factorio() {
    // full-bleed iframe with its own background - suppress the global grain
    // wallpaper so it can't bleed behind it (same as the home page)
    useEffect(() => {
        document.body.classList.add('home-page');
        return () => document.body.classList.remove('home-page');
    }, []);

    return (
        <>
            <Helmet>
                <title>ojee / Factorio Server</title>
                <meta name="description" content="Headless Factorio server - live status and an on/off switch." />
                <link rel="canonical" href="https://ojee.net/factorio" />
            </Helmet>
            <iframe
                title="ojee.net factorio"
                src="/redesign-demos/factorio/index.html?v=3"
                style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100dvh', border: 0, background: '#06060a', zIndex: 1 }}
            />
        </>
    );
}

export default Factorio;
